import { render, staticRenderFns } from "./CanvasContextMenu.vue?vue&type=template&id=47a2e2d5&scoped=true"
import script from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasContextMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanvasContextMenu.vue?vue&type=style&index=0&id=47a2e2d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2e2d5",
  null
  
)

export default component.exports